import React, { useEffect, useState } from 'react'
import { FormControl } from '@material-ui/core'
import {
  useSelections,
  SelectionContextProvider,
} from '../../../Contexts/SelectionContext'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'


import coreTheme from '../../theme'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import { PickerChangeHandlerContext, DateValidationError } from '@mui/x-date-pickers/models';

const theme = createTheme(
  {
    overrides: {
      MuiFormControl: {
        root: {
          [coreTheme.breakpoints.down('sm')]: {
            // width: '100%'
            width: '225px',
          },
          [coreTheme.breakpoints.up('sm')]: {
            width: '225px',
          },
        },
      },
      MuiFormLabel: {
        root: {
          color: 'black',
        },
      },
    },
  },
  coreTheme
)

export const FromDateFilter: React.FC<Partial<DatePickerProps<DateTime>>> = (
  props: DatePickerProps<DateTime> & { defaultValue?: DateTime }
) => {
  const [value, setValue] = useState(props.defaultValue)
  const selections = useSelections()

  useEffect(() => {
    selections.setFromDate(props.defaultValue?.toJSDate())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!props.defaultValue])

  const handleChange = (val: DateTime, context: PickerChangeHandlerContext<DateValidationError>) => {
    if (props.onChange) props.onChange(val, context)
    selections.setFromDate(val?.toJSDate())
    setValue(val)
  }
  return (
    <ThemeProvider theme={theme}>
      <FormControl>
        <DatePicker
          {...props}
          value={props.value ?? value ?? null}
          onChange={handleChange}
          clearable
          autoOk
          label="From Date"
          placeholder="From Date"
          emptyLabel="From Date"
          maxDateMessage="From date cannot be greater than the current date"
        />
      </FormControl>
    </ThemeProvider>
  )
}
